import {
  configureStore,
  createListenerMiddleware,
  isAnyOf,
  Tuple
} from '@reduxjs/toolkit';
import { updateCart } from '@front-office/app-common-cart';
import { fetchCart } from './helpers';
import {
  updateProducts,
  deleteAllProducts
} from './products';
import {
  applyPromocode,
  removePromocode,
  updatePromocode
} from './promocode';
import { fetchRecommendationProducts } from './recommendationProducts';
import { rootReducer } from './rootReducer';
import { updateSummary } from './summary';
import {
  FetchCartFulfilled,
  CartEmptiedSuccessfully,
  CartEmptyLoaded,
  OnAfterCartDelete
} from '../services/dispatchers';
import { storeName } from './products/consts';

const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  matcher: isAnyOf(
    removePromocode.fulfilled,
    applyPromocode.fulfilled
  ),
  effect: async () => {
    updateCart();
  }
});

listenerMiddleware.startListening({
  actionCreator: fetchCart.fulfilled,
  effect: async ({ payload }, listenerApi) => {
    listenerApi.dispatch(updateSummary(payload.summary));
    listenerApi.dispatch(updateProducts(payload.products));
    listenerApi.dispatch(
      updatePromocode(payload.promocode)
    );
    listenerApi.dispatch(
      fetchRecommendationProducts(
        Object.keys(payload.products)
      )
    );

    if (Object.keys(payload?.products)?.length > 0) {
      FetchCartFulfilled.dispatch(payload);
    } else {
      CartEmptyLoaded.dispatch();
    }
  }
});

listenerMiddleware.startListening({
  actionCreator: deleteAllProducts.pending,
  effect: async (_, listenerApi) => {
    const state = listenerApi.getState() as RootState;
    const ids = state[storeName]?.ids;

    CartEmptiedSuccessfully.dispatch(state);
    OnAfterCartDelete.dispatch(ids);
  }
});

listenerMiddleware.startListening({
  actionCreator: deleteAllProducts.fulfilled,
  effect: async (_, listenerApi) => {
    listenerApi.dispatch(fetchCart());
  }
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    new Tuple(
      ...getDefaultMiddleware(),
      listenerMiddleware.middleware
    )
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch<any>; // eslint-disable-line
